import { render, staticRenderFns } from "./ClientRequest.vue?vue&type=template&id=51b0f700&scoped=true&"
import script from "./ClientRequest.vue?vue&type=script&lang=js&"
export * from "./ClientRequest.vue?vue&type=script&lang=js&"
import style0 from "./ClientRequest.vue?vue&type=style&index=0&id=51b0f700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0f700",
  null
  
)

export default component.exports